import { createContext } from 'react';

const DealerRequestModalContext = createContext(void 0);

DealerRequestModalContext.displayName = 'context(DealerRequestModal)';

export default DealerRequestModalContext;